module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"range":"Range","includes":"Includes"},"es":{"range":"Rango","includes":"Incluye"}}')
  delete Component.options._Ctor
}
